import { depositProgressBarConstant } from '../constant';

export const depositProgressBarAction = {
    getDepositProgressBarDetails,
};

function getDepositProgressBarDetails(data) {
    return (dispatch) => {
        dispatch({ 
            type: depositProgressBarConstant.GET_DEPOSIT_PROGRESS_BAR_DETAILS, 
            payload: data 
        });
    };
}
